import VueI18n from 'vue-i18n';
import {store} from '../store/store';
import Messages from './translations';
import Vue from 'vue';

Vue.use(VueI18n);

export default new VueI18n({
    locale: store.getters['user/auth/locale'],
    messages: Messages,
});



// WEBPACK FOOTER //
// ./src/translations/i18n-setup.js